import { put, call, takeEvery } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import {
  OUTREACH_FORM_REQUEST,
  UPDATE_OUTREACH_FORM_REQUEST,
  OUTREACH_FORMS_STATUS_REQUEST,
} from './actionTypes';
import {
  outreachFormSuccess,
  outreachFormFailure,
  updateOutreachFormSuccess,
  updateOutreachFormFailure,
  outreachFormsStatusSuccess,
  outreachFormsStatusFailure,
} from './actions';
import OutreachFormService from '../../services/OutreachFormService';

export function* getOutreachFormTask(action) {
  try {
    const { dealerId, templateId } = action.payload;
    const responseData = yield call(
      OutreachFormService.getOutreachForm,
      dealerId,
      templateId,
    );
    yield put(outreachFormSuccess(responseData));
  } catch (error) {
    yield put(outreachFormFailure(error));
  }
}

export function* getOutreachFormsStatusTask(action) {
  try {
    const requestParams = action.payload;
    const responseData = yield call(
      OutreachFormService.getOutreachFormsStatus,
      requestParams.dealerId,
    );
    yield put(outreachFormsStatusSuccess(responseData));
  } catch (error) {
    yield put(outreachFormsStatusFailure(error));
  }
}

export function* updateOutreachFormTask(action) {
  try {
    const responseData = yield call(
      OutreachFormService.updateOutreachForm,
      action.payload,
    );
    yield put(updateOutreachFormSuccess(responseData));
    const { dealerId } = responseData;
    yield put(push(`/${dealerId}/outreach/`));
  } catch (error) {
    yield put(updateOutreachFormFailure(error));
  }
}

export function* outreachFormsSaga() {
  yield takeEvery(OUTREACH_FORM_REQUEST, getOutreachFormTask);
  yield takeEvery(OUTREACH_FORMS_STATUS_REQUEST, getOutreachFormsStatusTask);
  yield takeEvery(UPDATE_OUTREACH_FORM_REQUEST, updateOutreachFormTask);
}
